export default __webpack_public_path__ + "static/media/v4.6ea8529b.svg";